// import qs from "qs"
// import Jsona from "jsona"
// import ApiService from "@/store/services/api.service"
import ApiService from "./api.service"

export const MenuItemService = {
  list() {
    return ApiService.get(`menu-item`)
  },
}

// const url = "http://localhost"
// // const url = process.env.VUE_APP_API_BASE_URL
// const jsona = new Jsona()

// // function list(params) {
// //   let options = {
// //     params: params,
// //     paramsSerializer: function (params) {
// //       return qs.stringify(params, {encode: false});
// //     },
// //     headers: {
// //       'Accept': 'application/vnd.api+json',
// //       'Content-Type': 'application/vnd.api+json',
// //     },
// //   };

// //   return axios.get(`${url}/roles`, options)
// //     .then(response => {
// //       return {
// //         list: jsona.deserialize(response.data),
// //         meta: response.data.meta
// //       };
// //     });
// // }

// function get() {
//   const options = {
//     headers: {
//       // Accept: "application/vnd.api+json",
//       // "Content-Type": "application/vnd.api+json",
//     },
//   }

//   //   return axios.get(`${url}/roles/${id}`, options).then((response) => {
//   return axios
//     .get(`${url}/tennis-site/public/api/test`, options)
//     .then((response) => {
//       return response.data
//       // return JSON.parse(response.data)
//       return jsona.deserialize(response.data)
//       // let role = jsona.deserialize(response.data)
//       // delete role.links
//       // return role
//     })
// }

// // function add(role) {
// //   const payload = jsona.serialize({
// //     stuff: role,
// //     includeNames: null
// //   });

// //   const options = {
// //     headers: {
// //       'Accept': 'application/vnd.api+json',
// //       'Content-Type': 'application/vnd.api+json',
// //     }
// //   };

// //   return axios.post(`${url}/roles`, payload, options)
// //     .then(response => {
// //       return jsona.deserialize(response.data);
// //     });
// // }

// // function update(role) {
// //   const payload = jsona.serialize({
// //     stuff: role,
// //     includeNames: []
// //   });

// //   const options = {
// //     headers: {
// //       'Accept': 'application/vnd.api+json',
// //       'Content-Type': 'application/vnd.api+json',
// //     }
// //   };

// //   return axios.patch(`${url}/roles/${role.id}`, payload, options)
// //     .then(response => {
// //       return jsona.deserialize(response.data);
// //     });
// // }

// // function destroy(id) {
// //   const options = {
// //     headers: {
// //       'Accept': 'application/vnd.api+json',
// //       'Content-Type': 'application/vnd.api+json',
// //     }
// //   };

// //   return axios.delete(`${url}/roles/${id}`, options);
// // }

// export default {
//   //   list,
//   get,
//   //   add,
//   //   update,
//   //   destroy
// }
